module.exports = __webpack_public_path__ + "static/media/iv_savings.25ec94ea.svg";